import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

import { Dimensions, Serie } from '../../models';

@Component({
    selector: '[aaColumns]',
    templateUrl: './columns.component.html',
    styleUrls: [
        './columns.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ColumnsComponent implements OnInit
{
    @Input() dimensions: Dimensions;
    @Input() series: Serie[];
    @Input() stacked: boolean;

    constructor ()
    { }

    ngOnInit ()
    {
    }
}
